import { axios } from "helper/axios";
import { jarvisPrimeExistingHoldingConstants } from "./jarvisPrimeExistingHoldingConstants";

const jarvisPrimeExistingHoldingApis = {};

jarvisPrimeExistingHoldingApis.getPrimeList = () => {
  return axios.get(
    jarvisPrimeExistingHoldingConstants.EXISTING_HOLDING_PRIME_LIST_API
  );
};

jarvisPrimeExistingHoldingApis.getStockList = ({ primeId, isTemp }) => {
  const uri = `${jarvisPrimeExistingHoldingConstants.EXISTING_HOLDING_EDIT_STOCK_API}/${primeId}/stock`;
  return axios.get(uri, { params: { temp: isTemp } });
};

jarvisPrimeExistingHoldingApis.updatePrimeName = ({
  primeId,
  primeName,
  isTemp,
}) => {
  return axios.patch(
    `${jarvisPrimeExistingHoldingConstants.EXISTING_HOLDING_PRIME_LIST_API}/${primeId}`,
    { primeName },
    { params: { temp: isTemp } }
  );
};

jarvisPrimeExistingHoldingApis.removePrime = ({ primeId, isTemp }) => {
  return axios.delete(
    `${jarvisPrimeExistingHoldingConstants.EXISTING_HOLDING_REMOVE_PRIME_API}/${primeId}`,
    { params: { temp: isTemp } }
  );
};

jarvisPrimeExistingHoldingApis.addStockToPrime = ({
  primeId,
  isTemp,
  stockId,
  stockSymbol,
  stockQuantity,
  stockBuyPrice,
  stockBuyDate,
}) => {
  return axios.post(
    `${jarvisPrimeExistingHoldingConstants.EXISTING_HOLDING_ADD_STOCK_TO_PRIME_API}/${primeId}/stock`,
    { stockId, stockSymbol, stockQuantity, stockBuyPrice, stockBuyDate },
    { params: { temp: isTemp } }
  );
};

jarvisPrimeExistingHoldingApis.removeStockToPrime = (body, primeId) => {
  let temp = 0;
  return axios.patch(
    `${jarvisPrimeExistingHoldingConstants.EXISTING_HOLDING_REMOVE_STOCK_TO_PRIME_API}/${primeId}/stock?temp=${temp}`,
    body
  );
};

jarvisPrimeExistingHoldingApis.deleteStock = ({
  primeId,
  isTemp,
  deletePayload = [],
}) => {
  return axios.patch(
    `${jarvisPrimeExistingHoldingConstants.EXISTING_HOLDING_REMOVE_STOCK_TO_PRIME_API}/${primeId}/stock`,
    { primeStockIds: deletePayload },
    { params: { temp: isTemp } }
  );
};

jarvisPrimeExistingHoldingApis.editStock = ({
  primeId,
  isTemp,
  editPayload = [],
}) => {
  return axios.put(
    `${jarvisPrimeExistingHoldingConstants.EXISTING_HOLDING_EDIT_STOCK_API}/${primeId}/stock`,
    { stockData: editPayload },
    { params: { temp: isTemp } }
  );
};

jarvisPrimeExistingHoldingApis.editStockList = (body, primeId) => {
  let temp = 0;
  return axios.put(
    `${jarvisPrimeExistingHoldingConstants.EXISTING_HOLDING_EDIT_STOCK_API}/${primeId}?temp=${temp}`,
    body
  );
};

export { jarvisPrimeExistingHoldingApis };
